import type { CalendarOptionType } from './add-to-calendar.interface'

export interface CalendarOption {
  name: string
  icon: string
  type: CalendarOptionType
}

export const CALENDAR_OPTIONS: CalendarOption[] = [
  { name: 'Google Calendar', icon: 'calendarAlt', type: 'google' },
  { name: 'Outlook', icon: 'calendarAlt', type: 'outlook' },
  { name: 'Yahoo Calendar', icon: 'calendarAlt', type: 'yahoo' },
  { name: 'Download .ics', icon: 'download', type: 'ics' },
]
